import { Dispatch } from 'redux';
import { api } from '../../service/api';
import { CLIENTS_ACTIONS, handleError } from './actions';

export const getUIModules = () => (dispatch: Dispatch) => {
  api
    .getUIModules()
    .then((res) => {
      dispatch({
        type: CLIENTS_ACTIONS.UI_MODULES,
        payload: res.data,
      });
    })
    .catch((err) => {
      handleError(dispatch, err);
    });
};
